export const DRAWER_TYPES = {
  USERS: 'users',
  EVENTS: 'events',
  FORMS: 'forms',
  DELAYS: 'delays',
};
